import React, { useRef, useEffect } from 'react';
import { useLanguage } from '../../../context/LanguageContext';

export default function LiveCameraCapture({ onCapture, onCancel }) {
  const inputRef = useRef(null);
  const { lang } = useLanguage();
  const isAr = lang === 'ar';

  useEffect(() => {
    // Automatically trigger native camera click on mount
    inputRef.current?.click();
  }, []);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        onCapture(event.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      onCancel();
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-[100] flex items-center justify-center p-4">
      <div className="text-center text-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-400 mx-auto mb-4" />
        <p className="font-bold mb-2">{isAr ? 'فتح الكاميرا...' : 'Ouverture de la caméra...'}</p>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          capture="environment"
          className="hidden"
          onChange={handleChange}
        />
        <button 
          onClick={onCancel} 
          className="mt-4 px-6 py-2 bg-gray-800 hover:bg-gray-700 rounded-xl text-white text-sm"
        >
          {isAr ? 'إلغاء' : 'Annuler'}
        </button>
      </div>
    </div>
  );
}
